<template>
  <div class="uk-grid uk-grid-small uk-child-width-1-2@m" data-uk-grid>
    <div :class="{ 'uk-form-controls': !$attrs.placeholder }">
      <v-select
        :options="makes"
        v-bind="$attrs"
        v-on="$listeners"
        name="makes"
        v-model="form.hersteller"
        :reduce="m => m.value"
        :clearable="false"
        placeholder="Hersteller"
        @input="onChange()"
        :class="[{ 'uk-form-danger': errors.length }]"
      >
      </v-select>
    </div>
    <div :class="{ 'uk-form-controls': !$attrs.placeholder }">
      <v-select
        :options="availableModels"
        v-bind="$attrs"
        v-on="$listeners"
        name="model"
        :reduce="m => m.label"
        :clearable="false"
        placeholder="Modell"
        v-model="form.modell"
        @input="onChange()"
        :class="[{ 'uk-form-danger': errors.length }]"
      >
      </v-select>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

import OpenIndicator from '../OpenIndicator.vue'
vSelect.props.components.default = () => ({
  OpenIndicator: OpenIndicator
});

export default {
  inheritAttrs: false,
  props: {
    value: {
      required: false,
      Type: String,
      default: ''
    },
  },
  components: {
    vSelect
  },
  data() {
    return {
      form: {
        hersteller: null,
        modell: null
      },
      makes: [
        {
          id: 9,
          label: 'Ford',
          value: 'ford',
          models: [
            { id: 200, label: 'Ranger', value: 'ranger' },
            {
              id: 217,
              label: 'Transit',
              value: 'transit'
            },
            { id: 347, label: 'Transit Connect', value: 'transit-connect' },
            {
              id: 943,
              label: 'Transit Courier',
              value: 'transit-courier'
            },
            { id: 362, label: 'Transit Custom', value: 'transit-custom' }
          ]
        },
        {
          id: 7,
          label: 'Mercedes-Benz',
          value: 'mercedes-benz',
          models: [
            { id: 209, label: 'Sprinter', value: 'sprinter' },
            {
              id: 1270,
              label: 'Sprinter III',
              value: 'sprinter-iii'
            }
          ]
        },
        {
          id: 15,
          label: 'VW',
          value: 'vw',
          models: [
            { id: 96, label: 'Amarok', value: 'amarok' },
            {
              id: 34,
              label: 'Caddy',
              value: 'caddy'
            },
            { id: 594, label: 'Caddy Maxi', value: 'caddy-maxi' },
            {
              id: 301,
              label: 'CRAFTER',
              value: 'crafter'
            },
            { id: 351, label: 'Multivan', value: 'multivan' },
            {
              id: 595,
              label: 'T6 Transporter',
              value: 't6-transporter'
            }
          ]
        }
      ]
    }
  },
  watch: {
    'form.hersteller': function(val, oldVal) {
      if (typeof this.form.modell === 'undefined') {
        this.form.modell = null
      }
      if (typeof oldVal !== 'undefined' && oldVal !== null && val !== oldVal) {
        this.form.modell = null
      }
    }
  },
  computed: {
    availableModels() {
      const selectedMakeObj = _.find(this.makes, m => {
        return m.value === this.form.hersteller
      })

      return selectedMakeObj ? selectedMakeObj.models : []
    }
  },
  methods: {
    onChange() {
      this.$emit('change', this.form)
    }
  }
}
</script>
